import { useAnalyticContext } from '@application/analytic/analytic_link/mod';
import { withTranslation } from '@application/i18n/with_translation';
import { UnitService } from '@application/unit.service';
import { UniversalConfig } from '@application/universal_config.service';
import { Button, ButtonArrange, Flex } from '@cellula/react';
import { tokens } from '@cellula/react-theme-patient';
import { Illustration } from '@component/illustration/mod';
import { Title } from '@component/title.component';
import { TopBar } from '@component/top_bar.component';
import { OpeningHours } from '@view/view_create_new_message/screens/closed/use-opening-hours';
import { RuleSetType } from '@visiba/api-vcs-client-v2';
import { useResolve, useResolveController } from '@visiba/instantiation';
import { useEffect } from 'react';
import styled from 'styled-components';
import { ViewRedRobinController } from '../view_red_robin.controller';

const elements = {
	container: styled(Flex)`
		text-align: center;
		max-width: 400px;
	`,
	illustration: styled(Illustration)`
		width: 200px;
		/* height: 125px; */
		max-width: 100%;
	`,
};

export function ScreenClosed() {
	const controller = useResolveController(ViewRedRobinController);
	const analytics = useAnalyticContext();
	const universalConfig = useResolve(UniversalConfig);
	const unitService = useResolve(UnitService);
	const unit = unitService.getUnitNodeInTree(universalConfig.selectedUnitId);
	const receptionId = unit.receptionId;
	const openingHours = OpeningHours({ type: RuleSetType.TriageEntry, receptionId });
	const closedReason = controller.flowData.value.value?.closedReason ?? 'Other';

	function handleGoToHome() {
		analytics.trackEvent('Clicked start over');
		controller.goToReceptionHome();
	}

	function numbers() {
		const country = universalConfig.selectedCountryCode.peek();

		switch (country) {
			case 'SE':
				return {
					emergency: '112',
					nonEmergency: '1177',
				};
			case 'NO':
				return {
					emergency: '113',
					nonEmergency: '116 117',
				};
			case 'FI':
				return {
					emergency: '112',
					nonEmergency: '116 117',
				};
			case 'GB':
				return {
					emergency: '999',
					nonEmergency: 'NHS 111',
				};
		}

		return {
			emergency: '-',
			nonEmergency: '-',
		};
	}

	useEffect(
		function whenMounted() {
			analytics.service.trackPageView({
				customTitle: 'RedRobin: Closed',
			});
		},
		[analytics],
	);

	return (
		<>
			<TopBar.Content onAbort={null} />
			<Flex gap={tokens.spacing.x4} grow={1} align='center' justify='center'>
				<elements.container align='center' gap={tokens.spacing.x2_5} grow={1}>
					<elements.illustration type='closed' />
					<Title
						title={withTranslation(`View.RedRobin.Closed.${closedReason}Title`)}
						titleSize='small'
						description={withTranslation(`View.RedRobin.Closed.${closedReason}Body`, {
							emergencyNumber: numbers().emergency,
							nonEmergencyNumber: numbers().nonEmergency,
						})}
					/>
				</elements.container>
				{openingHours}
				<Flex style={{ width: '100%' }}>
					<ButtonArrange justify='center'>
						<Button variant='primary' onClick={handleGoToHome}>
							{withTranslation('View.RedRobin.Closed.Button')}
						</Button>
					</ButtonArrange>
				</Flex>
			</Flex>
		</>
	);
}
